import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddProducts.css";
import { useTranslation } from "react-i18next";
function AddProducts() {
  const { t } = useTranslation("backend");
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [userDetail, setUserDetail] = useState([]);
  const [planDetail, setPlanDetail] = useState([]);
  // State for user and product information
  const [formData, setFormData] = useState({
    plan_name: "",
    expiry_date: "",
    email: "",
    status: "",
    domain_name: null,
    url: null,
    id: null,
    password: null,
  });
  const handleChange = (e, stateUpdater) => {
    const { name, value } = e.target;
    stateUpdater((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  useEffect(() => {
    fetchDetails();
  }, []);
  const [loading, setLoading] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setLoading(true); // start loading
      const response = await fetch(`${BASE_URL}/add-user-subscription`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const result = await response.json();
      if (response.ok) {
        alert(result.message);
        navigate(-1);
      } else {
        alert(result.error);
      }
    } catch (error) {
      console.error("Error adding user:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchDetails = async () => {
    try {
      const response = await fetch(`${BASE_URL}/get/addSubcripions`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const details = await response.json();
      // Check if the response status is OK (200)
      if (response.ok) {
        setUserDetail(details.userDetail);
        setPlanDetail(details.planDetail);
        console.log(details);
      }
    } catch (error) {
      alert(error);
    }
  };

  const handleBack = (e) => {
    e.preventDefault();
    navigate(-1);
  };
  return (
    <div className="edit-contain">
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(38, 48, 67, 0.5)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              border: "6px solid #e0e0e0",
              borderTop: "6px solid #0f4b60",
              borderRadius: "50%",
              width: "60px",
              height: "60px",
              animation: "spin 1s linear infinite",
              marginBottom: "20px",
            }}
          />
          <div style={{ color: "#fff", fontSize: "20px", fontWeight: "600" }}>
            Please wait...
          </div>

          <style>
            {`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}
          </style>
        </div>
      )}
      <h2>{t("add_subscriptions")}</h2>
      <div className="container-edit details-container">
        <form onSubmit={handleUpdate} className="edit-form">
          {/* Product Fields */}
          <div className="form-group">
            <label>{t("select_pkg")}:</label>
            <select
              name="plan_name"
              value={formData.plan_name}
              onChange={(e) => handleChange(e, setFormData)}
              required
            >
              <option value="">{t("select_pkg")}</option>
              {planDetail.map((pkg) => (
                <option key={pkg.plan_name} value={pkg.plan_name}>
                  {pkg.plan_name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>{t("expiry")}</label>
            <input
              type="date"
              name="expiry_date"
              value={formData.expiry_date}
              onChange={(e) => handleChange(e, setFormData)}
              style={{
                width: "100%",
                border: "1px solid rgb(204, 204, 204)",
                borderRadius: "3px",
                padding: "0px 10px",
              }}
              required
            />
          </div>

          {/* User Fields */}
          <div className="form-group">
            <label>{t("user")}</label>
            <select
              name="email"
              value={formData.email}
              onChange={(e) => handleChange(e, setFormData)}
              required
            >
              <option value="">{t("select_user")}</option>
              {userDetail.map((user) => (
                <option key={user.email} value={user.email}>
                  {user.name} - {user.email}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>{t("domain")}:</label>
            <input
              type="text"
              name="domain_name"
              value={formData.domain_name}
              onChange={(e) => handleChange(e, setFormData)}
            />
          </div>

          <div className="credentials-container">
            <h3>{t("credetials")}</h3>

            <div className="form-group">
              <label>{t("url")}</label>
              <div className="input-container">
                <input
                  type="text"
                  name="url"
                  value={formData.url}
                  onChange={(e) => handleChange(e, setFormData)}
                />
              </div>
            </div>

            <div className="form-group">
              <label>{t("id")}</label>
              <div className="input-container">
                <input
                  type="text"
                  name="id"
                  value={formData.id}
                  onChange={(e) => handleChange(e, setFormData)}
                />
              </div>
            </div>

            <div className="form-group">
              <label>{t("password")}</label>
              <div className="input-container">
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={(e) => handleChange(e, setFormData)}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label>{t("status")}:</label>
            <select
              name="status"
              value={formData.status}
              onChange={(e) => handleChange(e, setFormData)}
              required
            >
              <option value="">{t("select_status")}</option>
              <option value="active">Active</option>
              <option value="create">Create</option>
              <option value="progress">Progress</option>
              <option value="suspended">Suspended</option>
              <option value="deleted">Deleted</option>
            </select>
          </div>

          <div className="save-back-btn-class">
            <button className="back-btn" onClick={handleBack}>
              {t("back")}
            </button>
            <button type="submit" className="submit-button">
              {t("save")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddProducts;
